module.exports = __webpack_public_path__ + "img/mesa_el_f.370bb5b3.png";